// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".status--iBOH2{color:green;border-color:green}", "",{"version":3,"sources":["webpack://./src/gui/Components/Status/Submitted/index.module.scss"],"names":[],"mappings":"AAAA,eAAQ,WAAW,CAAC,kBAAkB","sourcesContent":[".status{color:green;border-color:green}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"status": "status--iBOH2"
};
export default ___CSS_LOADER_EXPORT___;
